import { Infinity as InfinityIcon } from "lucide-react";

const SEGMENTS = 6;

export default function QuotaIndicator({ quota, slug }) {
    return (
        <div data-testid={`quota-indicator-${slug}`} className="w-full">
            <div className="mb-1.5 flex items-center justify-between">
                <span className="font-code text-[10px] font-medium uppercase tracking-[0.18em] text-gray-500">
                    Quota
                </span>
                <span className="text-xs font-semibold text-gray-200">
                    {quota.label}
                </span>
            </div>
            {quota.type === "unlimited" ? (
                <div className="flex h-2 items-center overflow-hidden rounded-full bg-gradient-to-r from-violet-500 via-indigo-500 to-blue-500">
                    <InfinityIcon className="ml-1 h-3 w-3 text-white/90" />
                </div>
            ) : (
                <div className="flex gap-1">
                    {Array.from({ length: SEGMENTS }).map((_, i) => {
                        const filled =
                            quota.type === "variable" || i < quota.value;
                        return (
                            <span
                                key={i}
                                className={`h-2 flex-1 rounded-full ${
                                    quota.type === "variable"
                                        ? "stripe-seg"
                                        : filled
                                          ? "bg-gradient-to-r from-violet-500 to-indigo-500"
                                          : "bg-white/10"
                                }`}
                            />
                        );
                    })}
                </div>
            )}
            {quota.sublabel && (
                <p className="mt-1 text-[10px] text-gray-500">{quota.sublabel}</p>
            )}
        </div>
    );
}
